<dx-data-grid style="height: 100%; width:100%;" #list [dataSource]="_rows" [focusedRowEnabled]="true" [showRowLines]="true"
    [showColumnLines]="false" [showBorders]="false" [hoverStateEnabled]="false"
    [allowColumnResizing]="allowCustomisation" [allowColumnReordering]="allowCustomisation"
    [autoNavigateToFocusedRow]="false" [rowAlternationEnabled]="false" [noDataText]="'There are no records'"
    [keyExpr]="keyProperty || 'id'" (onCellPrepared)="onCellPrepared($event)" (onRowPrepared)="onRowPrepared($event)" 
    (onEditorPreparing)="onEditorPreparing($event)" (onRowDblClick)="onRowDblClick($event)"
    (onSelectionChanged)="selectionChanged($event)" (onRowUpdated)="rowUpdated($event)"
    columnAutoWidth="true" columnResizingMode="widget"
    >

    <dxo-master-detail *ngIf="detailTemplate && (detailTemplate==='subjectLinksDetail')"
        [enabled]="detailTemplate ? true:false" template="subjectLinksDetail"></dxo-master-detail>
    <dxo-master-detail *ngIf="detailTemplate && (detailTemplate==='jsonDetail')" [enabled]="detailTemplate ? true:false"
        template="jsonDetail"></dxo-master-detail>
    <dxo-scrolling mode="standard" rowRenderingMode="virtual"></dxo-scrolling>
    <dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
    <dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
    <dxo-paging [pageSize]="showPager ? 10:0"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="showPager" [showNavigationButtons]="showPager"
        [allowedPageSizes]="[10, 20, 50, 0]" [showInfo]="showRowCount" infoText="Page {0} of {1} ({2} records)"
        [visible]="showPager || showRowCount">
    </dxo-pager>
    <dxo-search-panel [visible]="showSearch"></dxo-search-panel>
    <dxo-group-panel [visible]="allowCustomisation" style="padding-top: 24px;"></dxo-group-panel>
    <dxo-column-chooser [enabled]="allowCustomisation"></dxo-column-chooser>

    <dxo-selection *ngIf="!showSelection" [mode]="selectionMode" showCheckBoxesMode="none"></dxo-selection>
    <dxo-selection *ngIf="showSelection" mode="multiple" selectAllMode="allMode" showCheckBoxesMode="always">
    </dxo-selection>

    <dxo-state-storing [enabled]="true" type="custom" [storageKey]="storageKey" [customLoad]="loadState"
        [customSave]="saveState" [savingTimeout]="2000">
    </dxo-state-storing>

    <dxo-editing mode="cell" [allowUpdating]="true">
    </dxo-editing>

    <dxi-column *ngIf="showButtons" dataField="id" caption="Id" [width]="detailTemplate ? 64: 96" cellTemplate="buttons"
        [showInColumnChooser]="false" [allowEditing]="false" [allowFiltering]="false" [allowReordering]="false"
        [allowGrouping]="false" [allowHiding]="false" [allowSorting]="false" [allowResizing]="false">
    </dxi-column>
    <div *dxTemplate="let cell of 'buttons'" style="text-align: left;">
        <i *ngIf="allowEdit && (cell.data.canEdit===true  || cell.data.canEdit==undefined)" class="material-icons clickable edit" id="{{'btnEdit_' + cell.data[keyProperty || 'id']}}"
            matTooltip="Edit" (click)="edit(cell.data)" aria-label="Edit">edit</i>
        <i *ngIf="!(allowEdit && (cell.data.canEdit===true  || cell.data.canEdit==undefined))" class="material-icons clickable edit" id="{{'btnView_' + cell.data[keyProperty || 'id']}}"
            matTooltip="View" (click)="edit(cell.data)" aria-label="View">open_in_new</i>
        <i class="material-icons clickable delete" id="{{'btnDelete_' + cell.data[keyProperty || 'id']}}"
            *ngIf="allowEdit && allowDelete && (cell.data.canDelete)" matTooltip="Delete" aria-label="Delete"
            (click)="delete(cell.data)">delete</i>
    </div>

    <dxi-column *ngFor="let col of _columns; let idx = index" dataField="{{col.prop || col.name}}"
        caption="{{col.name}}" dataType="{{col.dataType || 'string'}}" cellTemplate="{{col.cellTemplate}}"
        [calculateGroupValue]="col.groupValue" [allowEditing]="col.allowEditing || false"
        [allowFiltering]="col.allowFiltering" minWidth="{{col.width || 100}}"
        >
    </dxi-column>

    <dxo-summary>
        <dxi-group-item [column]="keyProperty || 'id'" summaryType="count" displayFormat="{0} records">
        </dxi-group-item>
        <dxi-group-item *ngIf="showValueSummary" column="{{valueColumnName}}" summaryType="sum"
            displayFormat="Total: {0}" [alignByColumn]="true" [showInGroupFooter]="false" alignment="left"
            valueFormat="{{valueFormat}}">
        </dxi-group-item>

        <dxi-total-item *ngIf="showValueSummary" column="{{valueColumnName}}" summaryType="sum"
            displayFormat="Total: {0}" alignment="left" valueFormat="{{valueFormat}}">
        </dxi-total-item>
    </dxo-summary>

    <div *dxTemplate="let cell of 'yesnoCellTemplate'" style="text-align: left;">
        {{ getYesNoText(cell) }}
    </div>

    <div *dxTemplate="let cell of 'defaultCellTemplate'" style="text-align: left;" [calculateCellValue]="getDefaultTextCellValue">            
    </div>

    <div *dxTemplate="let cell of 'currencyCellTemplate'" style="text-align: left;">
        {{cell.value | currency:'GBP':'symbol':'1.2'}}
    </div>

    <div *dxTemplate="let cell of 'dateCellTemplate'" style="text-align: left;">
        {{cell.value | dateFormat}}
    </div>

    <div *dxTemplate="let cell of 'dateTimeCellTemplate'" style="text-align: left;">
        {{cell.value | dateFormat}} {{cell.value | date:'HH:mm:ss'}}
    </div>

    <div *dxTemplate="let cell of 'linkCellTemplate'" style="text-align: left;">
        <a class="clickable" style="color:#0171b3" (click)="openLink(cell.data)">{{cell.value}}</a>
    </div>

    <div *dxTemplate="let cell of 'markerIconCellTemplate'" style="text-align: left;">
        <mat-icon [style.color]="cell.value">room</mat-icon>
    </div>

    <div *dxTemplate="let cell of 'markersCellTemplate'" style="text-align: left;">
        <mat-icon class="material-icons marker-icon" *ngFor="let subjectMarker of cell.value"
            [style.color]='subjectMarker.marker?.color' [matTooltip]='subjectMarker.marker?.name'>room</mat-icon>
    </div>

    <div *dxTemplate="let cell of 'reviewStatusCellTemplate'" style="text-align: left;">
        <div *ngIf="cell.value === 'Pending'" class="bg-orange review-status">Pending</div>
        <div *ngIf="cell.value === 'Accepted'" class="bg-green review-status">Accepted</div>
        <div *ngIf="cell.value === 'Rejected'" class="bg-red review-status">Rejected</div>
        <div *ngIf="cell.value === 'Reviewed'" class="mat-accent-bg review-status">Reviewed</div>
    </div>

    <div *dxTemplate="let cell of 'assessmentCellTemplate'" style="text-align: left;">
        <div *ngIf="cell.value">
            <div *ngIf="cell.data.assessmentReviewStatus === statusAccepted" class="bg-green review-status">
                {{cell.value}} / {{cell.data.assessmentThreshold}}</div>
            <div *ngIf="cell.data.assessmentReviewStatus === statusRejected" class="bg-red review-status">{{cell.value}}
                / {{cell.data.assessmentThreshold}}</div>
            <div *ngIf="!cell.data.assessmentReviewStatus" class="mat-accent-bg review-status">{{cell.value}} /
                {{cell.data.assessmentThreshold}}</div>
        </div>
    </div>

    <!--Template for display of subject links in master/detail-->
    <div *dxTemplate="let subject of 'subjectLinksDetail'">
        <div *ngIf="subject.data.subjectLinks.length == 0" class="no-links">
            <div>There are no linked subjects</div>
        </div>
        <div *ngIf="subject.data.subjectLinks.length > 0" class="linkedsubjects mat-white-bg">
            <div class="p-8 pl-16 clickable link-row" *ngFor="let link of subject.data.subjectLinks"
                (click)="selectLink(link);" (dblclick)="openLink(link)"
                [ngClass]="{'selected':link?.id == selectedLink?.id, 'marker':link.linkedSubject.subjectMarkers?.length>0, 'linked-marker':link.linkedSubject.subjectMarkers?.length>0}">
                <div class="clickable" fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <!-- <div class="avatar" [style.background-color]="link.linkedSubject.subjectType?.color">{{link.linkedSubject.subjectType?.name[0]}}</div> -->
                        <div class="link-cell pl-8">
                            <mat-icon class="material-icons marker-icon"
                                *ngFor="let subjectMarker of link.linkedSubject.subjectMarkers"
                                [style.color]='subjectMarker.marker?.color' [matTooltip]='subjectMarker.marker?.name'>
                                room</mat-icon>
                        </div>
                        <div class="link-cell text-truncate">{{link.linkedSubject.subjectType?.name}}</div>
                        <div class="link-cell text-truncate">{{link.relationship?.name}}</div>
                        <div class="link-cell text-truncate">{{link.linkedSubject.reference}}</div>
                        <div class="text-truncate">{{link.linkedSubject.summary}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *dxTemplate="let detail of 'jsonDetail'">
        <div class="scrollable mat-white-bg">
            <pre [innerHtml]="detail.data.json | json:3"></pre>
        </div>
    </div>
</dx-data-grid>